<template>
    <TemplatesToursSingle />
</template>
